// @flow
import React, { PureComponent } from 'react';
import { getPublicAssets } from 'utils/assetsUtils';
import { formatFullDate, formatHours } from 'utils/dateUtils';
import { dynamicClassName } from 'utils/dynamicClassName';
import { getDateFromString } from 'utils/dateUtils';
import { handleTagEvent } from 'utils/tagManagerUtils';

import { nullMatchResult } from 'types/MatchResult';
import type { MatchResultType } from 'types/MatchResult';

type Props = {
  result: MatchResultType,
  title: string,
  small?: boolean
};

class MatchResult extends PureComponent<Props> {
  static defaultProps: Props = {
    result: {
      team1: {
        img: '/img/card/bg-game.jpg',
        name: '',
        score: ''
      },
      team2: {
        img: '/img/card/bg-game.jpg',
        name: '',
        score: ''
      },
      competitionType: 'Fédérale 2',
      link: '',
      pool: 'Poule 1',
      place: 'Stade Velodrome de Limoges',
      date: new Date(),
      statut: ''
    },
    title: 'Resultat de match',
    small: true
  };

  renderScore = (score: string, won: boolean) => {
    return won ? score : <span className="ft-300">{score}</span>;
  };

  renderDetails = () => {
    const {
      small,
      result: { competitionType, pool, place }
    } = this.props;

    if (!small) {
      return (
        <React.Fragment>
          <strong>{competitionType}</strong> — {pool}
          <br />
          <strong>{place}</strong>
        </React.Fragment>
      );
    }

    return null;
  };

  renderStatus = () => {
    const { team1, team2, statut } = this.props.result;

    if (statut === 'Terminé') {
      return (
        <React.Fragment>
          <span className="ft-h6 ft-up card__status">{statut}</span>
          <br />
          <span className="ft-h2">
            {this.renderScore(team1.score, team1.score > team2.score)} :{' '}
            {this.renderScore(team2.score, team2.score > team1.score)}
          </span>
        </React.Fragment>
      );
    } else {
      return (
        <React.Fragment>
          <span className="ft-h6 ft-up card__status">{statut}</span>
          <br />
          <span className="ft-h2">VS</span>
        </React.Fragment>
      );
    }
  };

  render() {
    const {
      result,
      result: { team1, team2 },
      small,
      title
    } = this.props;

    if (result === nullMatchResult) {
      return null;
    }

    const date = getDateFromString(new Date(this.props.result.date));

    const containerClassName = dynamicClassName('box card card--game ');
    small && containerClassName.add('card--small');

    return (
      <a
        href={this.props.result.link}
        className={containerClassName.build()}
        onClick={handleTagEvent('module match', 'clic lien sortant', 'https://competitions.ffr.fr/')}
        target="_blank"
        rel="noopener noreferrer"
      >
        <div
          className="card__thumbnail img-green"
          style={{ backgroundImage: `url(${getPublicAssets('/img/card/bg-game.jpg')})` }}
        />
        <div className="card__body">
          <h3 className="card__title">{!small && title}</h3>
          <p className={small ? 'ft-h6 mb-1' : 'ft-h6 mb-6'}>{`${formatFullDate(date)} — ${formatHours(date)}`}</p>
          <div className="card__row">
            <div className="img-circle">
              <img src={team1.img} alt={team1.name} />
            </div>
            <div>{this.renderStatus()}</div>
            <div className="img-circle">
              <img src={team2.img} alt={team2.name} />
            </div>
          </div>
          <div className="card__row card__team">
            <p>{team1.name}</p>
            <p>{team2.name}</p>
          </div>
          <p className="card__desc">{this.renderDetails()}</p>
        </div>
        <div className="card__footer">
          <span className="btn btn--white btn--full">
            <i className="icon icon-external is-inline"></i>
            <span>Voir les détails du match</span>
          </span>
        </div>
      </a>
    );
  }
}

export default MatchResult;
